<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
  <div class="loading-content">
    <div class="loading-spinner"></div>
    <p class="loading-text">Validating access...</p>
  </div>
</div>

<!-- Professional Landing Page with Two Column Layout -->
<div *ngIf="!isLoading && hasValidGuid" class="homepage-container">
  <!-- Header -->
  <header class="header" style="display: none;">
    <div class="header-content">
      <div class="brand">
        <h1 class="brand-title">🤖 Website&nbsp;</h1>
        <span class="brand-subtitle"> Builder Agent</span>
      </div>
    </div>
  </header>

  <!-- Main Hero Section -->
  <main class="hero-section">
    <div class="hero-container">
      <!-- Left Content -->
      <div class="hero-content">
        <div class="welcome-badge">
          <span class="badge-text">✨ Welcome</span>
        </div>
                
        <div class="hero-message">
          
          <p class="message-text">
            Now that you're all set up, it's time to create your own professional website 
            using our simple and powerful Website Builder — all in just a few easy steps.
          </p>
        </div>
        
        <div class="hero-actions">
          <button class="cta-button btn-primary" (click)="startBuildingV2()">
            <span class="cta-text">Let's build something great together!</span>
            <span class="cta-icon">🚀</span>
          </button>
          
          <!-- <button class="cta-button btn-secondary" (click)="startBuildingV2()">
            <span class="cta-text">Try New Form Builder (V2)</span>
            <span class="cta-icon">✨</span>
          </button> -->
        </div>
      </div>
      
      <!-- Right Image -->
      <div class="hero-image">
        <div class="image-container">
          <img src="https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Website Design and Development" class="preview-image">
          <div class="image-overlay">
            <div class="floating-card card-1">
              <div class="card-icon">🚀</div>
              <span>Fast Setup</span>
            </div>
            <div class="floating-card card-2">
              <div class="card-icon">🎨</div>
              <span>Beautiful Design</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  
  <!-- Footer -->
  <footer class="footer" style="display: none;">
    <p class="footer-text">Powered by OTTO • Built for professionals</p>
  </footer>
</div> 